import { atom } from 'recoil';
import { getUUID } from '../../utils';

export const reportLoaderState = atom<boolean>({
  key: getUUID(),
  default: false,
});
